/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState, useRef } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Box,
  Flex,
  Spinner,
  Text,
} from '@chakra-ui/react';

const PdfViewerModal = ({ pdfUrl, children }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const blobUrlRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isOpen || !pdfUrl) return undefined;

    setLoading(true);
    setError(null);
    setBlobUrl(null);

    fetch(pdfUrl)
      .then(res => {
        if (!res.ok) throw new Error(`Erro ao carregar PDF (${res.status})`);
        return res.blob();
      })
      .then(blob => {
        const url = URL.createObjectURL(blob);
        blobUrlRef.current = url;
        setBlobUrl(url);
      })
      .catch(err => {
        setError(err.message || 'Erro ao carregar PDF');
      })
      .finally(() => {
        setLoading(false);
      });

    return () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
        blobUrlRef.current = null;
      }
    };
  }, [isOpen, pdfUrl]);

  const handleClose = () => {
    if (blobUrlRef.current) {
      URL.revokeObjectURL(blobUrlRef.current);
      blobUrlRef.current = null;
    }
    setBlobUrl(null);
    setError(null);
    onClose();
  };

  return (
    <>
      {children ? (
        React.cloneElement(children, { onClick: onOpen })
      ) : (
        <Button onClick={onOpen}>Visualizar PDF</Button>
      )}

      <Modal isOpen={isOpen} onClose={handleClose} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Visualizar PDF</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box display="flex" justifyContent="center">
              {loading && (
                <Flex align="center" justify="center" h="65vh" direction="column" gap={3}>
                  <Spinner size="lg" color="blue.500" />
                  <Text color="gray.500" fontSize="sm">
                    Carregando PDF...
                  </Text>
                </Flex>
              )}
              {error && (
                <Flex align="center" justify="center" h="65vh" direction="column" gap={3}>
                  <Text color="red.500" fontSize="sm">
                    {error}
                  </Text>
                  <Button
                    size="sm"
                    colorScheme="blue"
                    variant="outline"
                    onClick={() => window.open(pdfUrl, '_blank')}
                  >
                    Abrir em nova aba
                  </Button>
                </Flex>
              )}
              {blobUrl && (
                <iframe src={blobUrl} style={{ width: '100%', height: '65vh' }} frameBorder="0" />
              )}
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PdfViewerModal;
